export default {
    name: "RealTimeUsageChartWidget",
    type: "ChartWidget",
    description: "A real-time chart showing usage.",
    roles: ["appUser"],
    widget: {
        title: "Real-time Usage",
        size: "large",
        chartType: "line",
        dataProvider: {
            main: {
                rpc: "SonarRpc.getRealTimeUsage" // Assuming this RPC exists
            }
        },
        options: {
            responsive: true,
            scales: {
                y: {
                    beginAtZero: true
                }
            },
            plugins: {
                legend: {
                    display: false
                }
            }
        }
    }
};